import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, CitationService, ListService, UserService } from '../../ajs-upgraded-providers';
import { AnnotationService } from '../../annotations/core/annotation.service';
import { AnnotationsStorageService } from '../../annotations/core/annotations-storage.service';
import { AnnotatorConfig } from '../../annotations/shared/annotator-config';
import { FlagService } from '../../core/flag.service';
import { MarkAsBrokenParams } from '../../mark-as-broken/mark-as-broken/mark-as-broken-params';
import { MarkAsBrokenServiceService } from '../../mark-as-broken/mark-as-broken/mark-as-broken-service.service';
import { CustomDialogWindow } from '../../rl-common/dialogs/shared/custom-dialog-window';
import { FileUtilsService } from '../../rl-common/file/core/file-utils.service';
import { FileService } from '../../rl-common/file/core/file.service';
import { RlFile } from '../../rl-common/file/shared/rl-file';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { EmbeddedMode } from '../../rl-common/shared/shared/embeded-mode.enum';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { Visibility } from '../../rl-common/shared/shared/types/visibility.enum';
import { ViewerService } from '../core/viewer.service';

@Component({
  selector: 'rl-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {
  content: RlFile;
  annotator: AnnotatorConfig = new AnnotatorConfig();
  showDownload: boolean;
  isGuest: boolean;
  student: boolean;
  showReportBroken: boolean = true;
  markAsBrokenDialog: CustomDialogWindow = new CustomDialogWindow();
  showAnnotations: boolean = true;
  authMethod: string;
  constructor(
    private flagService: FlagService,
    private fileService: FileService,
    private listService: ListService,
    private route: ActivatedRoute,
    private viewerService: ViewerService,
    private annotationService: AnnotationService,
    private authService: AuthService,
    private citationService: CitationService,
    private utils: UtilsService,
    private fileUtils: FileUtilsService,
    private markAsBrokenService: MarkAsBrokenServiceService,
    private annStorage: AnnotationsStorageService,
    private userService: UserService
  ) {
    this.annotator.allowRefresh = true;
    this.annotator.displayPrivatePublicTabs = true;
  }

  isDarkColor(colorInput) {
    if (!colorInput) return false;

    let c = colorInput;
    c = c.substring(1); // strip #
    let rgb = parseInt(c, 16); // convert rrggbb to decimal
    let r = (rgb >> 16) & 0xff; // extract red
    let g = (rgb >> 8) & 0xff; // extract green
    let b = (rgb >> 0) & 0xff; // extract blue

    let brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    return brightness < 128;
  }

  get user() {
    return this.userService.myuser;
  }

  onLogin() {
    this.listService.updateUrlInSession().then(() => (document.location.href = `../login?auth=${this.authMethod}`));
  }

  ngOnInit(): void {
    this.student = this.authService.isStudent();
    this.isGuest = this.authService.isGuest();
    this.showAnnotations = !this.utils.isTouchScreen();

    this.route.paramMap.subscribe((params) => {
      let entityId = params.get('entityId');
      let entityType = params.get('entityType') === 'favorites' ? EntityType.COLLECTION : (params.get('entityType').toUpperCase() as EntityType);
      let contentType = params.get('contentType');

      //read query parameter from URL
      this.authMethod = new URL(window.location.href).searchParams.get('auth');

      this.viewerService.get(entityType, entityId, contentType).subscribe((content) => {
        this.content = content;
        if (this.content.type == 'BOLK') {
          let url = document.location.href;
          url = url.split('readinglist')[0] + this.content.url;
          this.content.url = url;
        }
        this.updateCommentsVisibility();
        if (this.content.availabilityConf) {
          let pdfReadOnly = this.content.availabilityConf.embedded == EmbeddedMode.READONLY || this.flagService.isLegantoViewerReadOnly();
          this.showDownload = !pdfReadOnly;

          if (this.utils.isTouchScreen() && 'true' == new URLSearchParams(document.location.search).get('campusm')) {
            this.showDownload = false;
          }
        } else if (content.entityType === EntityType.COLLECTION) {
          this.showDownload = true;
        }
      });
    });

    this.showReportBroken = this.flagService.showMarkAsBrokenAll();
  }

  reportBrokenLink() {
    let markAsBrokenParams = new MarkAsBrokenParams(this.content.amazonFileKey, this.content.amazonDisplayFileName, 'fileDownload');
    this.markAsBrokenService.openMarkAsBrokenDialog(this.content.entityId, true, markAsBrokenParams, () => this.afterMarkAsBroken());
  }

  afterMarkAsBroken() {
    this.showReportBroken = false;
  }

  updateCommentsVisibility() {
    this.annotator.commentsConfig.visibility = this.content.allowAnnotations ? 'all' : 'private';
  }

  onChangeAnnotationToggle(e: string) {
    this.content.allowAnnotations = !this.content.allowAnnotations;
    this.updateCommentsVisibility();
    this.annotationService.enablePublicAnnotations(this.content.entityId as any, this.content.allowAnnotations).subscribe();
  }

  download() {
    this.fileService.download(this.content);
  }

  displayAnnottaionToggel() {
    return this.showAnnotations && this.content && this.flagService.isDisplayAnnottaionToggel() && (this.fileUtils.isPDF(this.content.amazonFileKey) || this.content.url);
  }

  annotationSwitch(event) {
    const visibility = event.toUpperCase() as Visibility;
    this.annStorage.setVisibility(visibility);
  }
}
